export default {
  MY_PAGE: 'MY_PAGE',
  COMPLETED_PAGE: 'COMPLETED_PAGE',
  ALL_PAGE: 'ALL_PAGE',
  RECENT_UPDATED_PAGE: 'RECENT_UPDATED_PAGE',
  DASHBOARD_PAGE: 'DASHBOARD_PAGE'
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/enums/pageType.js